import React from "react";
import s from "./styles.scss";
import withStyles from "isomorphic-style-loader/withStyles";
import { Col } from "reactstrap";
import WizardFormStep from "../../components/WizardFormStep";
import FormFieldRow from "../components/FormFieldRow";
import FormInput from "../../../../../../toolkit/formInput";
import * as yup from "yup";
import { createUrlField } from "../../../../../../utils/validation/validationUtils";

export const legalDocumentsFormSchema = yup.object({
  termsAndConditionUrl: createUrlField("Terms & Conditions URL"),
  privacyPolicyUrl: createUrlField("Privacy Policy URL"),
});

const LegalDocumentsForm: React.FC = () => {
  return (
    <WizardFormStep
      title="Add Required URLs"
      subtitle="Add URL address link for your organization’s Privacy Policy and Terms & Conditions"
      className={s.formContainer}
    >
      <FormFieldRow spacing="first">
        <FormInput
          name="termsAndConditionUrl"
          type="text"
          icon={"fa-solid fa-share-nodes"}
          placeholder="Terms & Conditions URL"
        />
      </FormFieldRow>
      <FormFieldRow>
        <FormInput
          name="privacyPolicyUrl"
          type="text"
          icon={"fa-solid fa-share-nodes"}
          placeholder="Privacy Policy URL"
        />
      </FormFieldRow>
      <FormFieldRow>
        <p className={s.needHelpText}>
          Need Help? Use our templates{" "}
          <a className={s.needHelpLink}>click here</a>
        </p>
      </FormFieldRow>
    </WizardFormStep>
  );
};

export default withStyles(s)(LegalDocumentsForm);
